import { render, staticRenderFns } from "./DocketEntryAttendeeNotifications.vue?vue&type=template&id=2e48e41f&scoped=true&"
import script from "./DocketEntryAttendeeNotifications.vue?vue&type=script&lang=js&"
export * from "./DocketEntryAttendeeNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DocketEntryAttendeeNotifications.vue?vue&type=style&index=0&id=2e48e41f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e48e41f",
  null
  
)

export default component.exports